import styles from "./styles.module.scss";
import { convertOfficeUserStatus } from "utils/convertOfficeUserStatus";
import { IUserOfficeStatus } from "dto/IUserOfficeStatus";
import { FC, Props } from "./typings";
import { useEffect, useRef, useState } from "react";
import workspaceService from "api/workspaceService";
import MembershipMoveStructureModal from "components/MembershipMoveStructureModal";
import MembershipEditRoleModal from "components/MembershipEditRoleModal";
import Avatar from "components/Avatar";
import BinIcon from "assets/icons/bin.svg?react";
import SendIcon from "assets/icons/send-color.svg?react";
import { IWorkspaceRole } from "dto/IWorkspace";
import StatusBadge from "components/StatusBadge";
import DropdownMui from "components/DropdownMui";
import DotsIcon from "assets/icons/three-dots.svg?react";
import { Option } from "components/OptionsCard/typings";
import classNames from "classnames";
import { default as Dropdown2 } from "components/OptionsCard/Dropdown";
import { ENotificationType, notification } from "utils/notification";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

const MembershipCard: FC<Props> = ({
  myPrivilages,
  roles,
  worker,
  refetch,
  structure,
}) => {
  const { t } = useTranslation();
  const [, setShowMenu] = useState(false);
  const [showStructure, setShowStructure] = useState(false);
  const { mutate: editUser } = workspaceService.useWorkspaceEditMember();
  const [showRole, setShowRole] = useState(false);
  const { mutate: removeWorker } = workspaceService.useRemoveUser();

  const rootRef = useRef(null);
  const refWrapper = useRef(null);

  const status = convertOfficeUserStatus(worker.Status);
  // const role = convertOfficeUserRole(worker.RoleId);

  const translate = () => {
    switch (status) {
      case IUserOfficeStatus.ACTIVE:
        return t("shareStatuses.active");
      case IUserOfficeStatus.INVITATION:
        return t("memberStatuses.invitedPassive");
      case IUserOfficeStatus.REJECTED:
        return t("memberStatuses.rejected");
      case IUserOfficeStatus.REMOVED:
        return t("shareStatuses.removed");
      case IUserOfficeStatus.WAITING_FOR_APPROVAL:
        return t("memberStatuses.invitedPassive");
    }
  };

  const getColor = () => {
    switch (status) {
      case IUserOfficeStatus.ACTIVE:
        return 11;
      case IUserOfficeStatus.INVITATION:
        return 5;
      case IUserOfficeStatus.REJECTED:
        return 2;
      case IUserOfficeStatus.REMOVED:
        return 14;
      case IUserOfficeStatus.WAITING_FOR_APPROVAL:
        return 5;
    }
  };

  const handleEditUser = (selectedRole: IWorkspaceRole) => {
    editUser(
      {
        Id: worker.Id,
        RoleId: selectedRole.Id,
      },
      {
        onSuccess: () => {
          refetch();
        },
      },
    );
  };

  const handleRemoveUser = () => {
    removeWorker(
      {
        Id: worker.Id,
      },
      {
        onSuccess: () => {
          refetch();
          setShowMenu(false);
        },
      },
    );
  };

  const handleResendInvitation = () => {
    notification({
      text: t("workspace.reinviteSent"),
      title: t("workspace.reinviteTitle"),
      type: ENotificationType.INFO,
    });
  };

  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [options, setOptions] = useState<Option[]>([
    {
      name: t("common.delete"),
      Icon: BinIcon,
      callback: () => {
        handleRemoveUser();
      },
      additional: false,
      isEnabled: myPrivilages.CanEditMembersInWorkspace,
      canMultiple: true,
    },
  ]);

  useEffect(() => {
    if (worker.Status === 1) {
      setOptions([
        ...options,
        {
          name: t("workspace.resendInvitation"),
          Icon: SendIcon,
          callback: () => {
            handleResendInvitation();
          },
          additional: false,
          isEnabled: myPrivilages.CanEditMembersInWorkspace,
          canMultiple: true,
        },
      ]);
    }
  }, []);

  // Przejęcie profilu członka przez administrację ZNIKA w modelu kluczy firmowych: dane
  // należą do firmy (jeden klucz firmy dla wszystkich członków), więc nie ma czego przejmować.

  return (
    <>
      <div className={styles.workerTab} ref={rootRef}>
        <div className={styles.data}>
          <div className={styles.name}>
            <Avatar
              className={styles.avatar}
              name={worker.Label}
              size="small"
            />{" "}
            {worker.Label}
          </div>
          {/* <div className={`${styles.status} ${getClassName()}`}>
            {translate()}
          </div> */}
          {/* <div className={styles.email}>{worker.Email}</div> */}
        </div>
        <div className={styles.menu}>
          {/* {isAdmin && !worker.IsMe ? (
          <Dropdown
          className={styles.d}
          defaultValue={role}
          list={roles}
          onChange={() => {}}
          />
        ) : ( */}
          <StatusBadge
            status={{
              Id: -1,
              Color: getColor(),
              Name: translate() ?? "",
              Type: 1,
              Global: false,
            }}
            onRemove={() => {}}
          />
          <div className={styles.role}>
            <DropdownMui
              size="small"
              variant="standard"
              hideBorder={true}
              defaultValue={worker.RoleId}
              list={roles.map((x) => {
                return { value: x.Id, name: x.Name };
              })}
              onChange={(v) => {
                handleEditUser(roles.find((x) => x.Id === v.value));
              }}
              disabled={
                worker.IsMe ||
                worker.IsOwner ||
                !myPrivilages.CanEditMembersInWorkspace
              }
            ></DropdownMui>
          </div>

          {/* )} */}

          {options.filter((x) => x.isEnabled).length > 0 && (
            <div className={styles.more} ref={refWrapper}>
              <Tooltip title={t("common.more")}>
                <div>
                  <DotsIcon
                    onClick={() => {
                      setShowDropdown(!showDropdown);
                    }}
                    className={classNames(styles.icon)}
                  />
                </div>
              </Tooltip>
            </div>
          )}
          <Dropdown2
            toggle={() => setShowDropdown(false)}
            options={options.filter((x) => x.isEnabled)}
            refWrapper={refWrapper}
            rightSide={false}
            scrollWrapper={rootRef}
            showOptions={showDropdown}
            selectedElements={[]}
          />
        </div>
      </div>
      {showStructure && (
        <MembershipMoveStructureModal
          structure={structure}
          member={worker}
          refetch={refetch}
          toggle={() => setShowStructure(false)}
        />
      )}
      {showRole && (
        <MembershipEditRoleModal
          roles={roles}
          member={worker}
          refetch={refetch}
          toggle={() => setShowRole(false)}
        />
      )}
    </>
  );
};

export default MembershipCard;
